
import { defineMessages } from 'react-intl'

export default defineMessages({
  notSupplied: {
    id: 'containers.CustomerOrdersPages.components.OrderRow.notSupplied',
    defaultMessage: 'Not supplied',
  },
  retake: {
    id: 'containers.CustomerOrdersPages.components.OrderRow.retake',
    defaultMessage: 'Retake',
  },
})
